import { Injectable } from '@angular/core';
import { PackageQuery } from '../../../models/package-query';
import { FilterService } from '../services/filter.service';
import { FilterAssistQuery } from '../../../interfaces/filter-assist-query';
import { FilterAssist } from '../../../models/filter-assist';
import { Observable, of } from 'rxjs';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';

@Injectable({
    providedIn: 'root'
})
export class PackageFilterService extends FilterService<PackageQuery> implements FilterAssistQuery<PackageQuery> {

    private PACKAGE_FILTER = 'PACKAGE_FILTER';

    constructor() {
        super();
        this.registerFilters(this);
    }

    protected describe(terms: string): string {
        return $localize`Filter for "${terms}"`;
    }

    active(query: PackageQuery): Observable<FilterAssist[]> {
        if (query.description) {
            return of([ {
                id: this.PACKAGE_FILTER,
                description: this.describe(query.description),
                score: 50,
                parameter: query.description,
                category: FilterCategoryEnum.ANY
            } ]);
        }
        return of([]);
    }

    apply(id: string, parameter: any, query: PackageQuery): void {
        switch (id) {
            case this.PACKAGE_FILTER:
                query.description = parameter;
                break;
        }
    }

    ids(): string[] {
        return [ this.PACKAGE_FILTER ];
    }

    match(terms: string): Observable<FilterAssist[]> {
        if (terms.length < 2) {
            return of([]);
        }
        return of([ {
            id: this.PACKAGE_FILTER,
            parameter: terms,
            score: 50,
            description: this.describe(terms),
            category: FilterCategoryEnum.ANY
        } ]);
    }

    unapply(id: string, query: PackageQuery): void {
        switch (id) {
            case this.PACKAGE_FILTER:
                query.description = null;
                break;
        }
    }
}
